import styled from 'styled-components';

import { Flex } from '../../atoms';

export const StyledModal = styled(Flex)`
  outline: none;
  overflow-y: ${props => props.overflowY || 'auto'};
`;
